<template>
    <div class="panel-content">
        <h2>Core facilities</h2>
        <img class="header" src="/static/img/overlay-assets/header7-4.jpg" />
        <p>Kernfaciliteiten van Tracer Center Amsterdam zijn een door de overheid erkend GMP-productielaboratorium voorzien van ultramoderne apparatuur voor synthese en kwaliteitscontrole, preklinische beeldvormingsvoorzieningen (optical imager van Bruker, PET-systemen van Mediso), organische chemielaboratoria, moleculaire biologielaboratoria, in-vivo-farmacologie en moderne behuizing voor laboratoriumdieren.</p>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    export default {

    };
</script>
